// src/store.js

import { configureStore } from '@reduxjs/toolkit';
import checkpointsReducer from './features/checkpointsSlice';
import actionAreasReducer from './features/actionAreasSlice';
import measuresReducer from './features/measuresSlice';
import dashboardReducer from './features/dashboardSlice';
import authReducer from './features/authSlice';
import unitsReducer from './features/unitsSlice';
import userReducer from './features/userSlice';
import tagsReducer from './features/tagsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    checkpoints: checkpointsReducer,
    actionAreas: actionAreasReducer,
    measures: measuresReducer,
    dashboard: dashboardReducer,
    units: unitsReducer,
    user: userReducer,
    tags: tagsReducer,
  },
});
